// ONB-007: salir de la app hacia una página ALOJADA del proveedor de cobro (guardar la tarjeta, portal de
// la suscripción). Aislado para poder probar las pantallas sin navegar de verdad. La URL siempre la entrega
// el backend; la web nunca la arma.
export function redirectTo(url: string): void {
  window.location.assign(url);
}
